import { createContext, useContext } from "react";

export type AppNavigationControl = {
  setMenuIsOpen: (v: boolean) => void,
}

export const AppNavigationControlContext = createContext<AppNavigationControl>({
  setMenuIsOpen: (v: boolean) => {},
});

export const useAppNavigationControlContext = () => useContext(AppNavigationControlContext);
